import dayjs from "dayjs"

import { CoachingGroup } from "../types"

export const isInactiveClient = (coachingGroup: CoachingGroup): boolean => {
  const inactivated = coachingGroup?.date_inactivated
  const reactivated = coachingGroup?.date_reactivated

  if (!inactivated) return false
  if (!reactivated || reactivated < inactivated) return true
  return false
}

export const isReactivatedClient = (coachingGroup: CoachingGroup): boolean => {
  const inactivated = coachingGroup?.date_inactivated
  const reactivated = coachingGroup?.date_reactivated

  if (!inactivated || !reactivated) return false
  if (reactivated < inactivated) return false

  const isNewlyReactivated = isNewClient(reactivated)
  if (isNewlyReactivated) return true

  return false
}

export const isNewClient = (createdAt: string) => {
  const threeDaysAgo = dayjs().subtract(3, "days")
  return dayjs(createdAt).isAfter(threeDaysAgo)
}
